import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';


export const rotateKitchenMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Rotate Kitchen',
		onClick: ({ controller }): void => {
			controller.viewport.actions.smoothRotation(controller.viewport.config.rotation + 90);
		}
	}
};
